<template>
  <div class="contactMePage">
    <buttonView @childEvent="$emit('childEvent')"></buttonView>

    <!-- 顶部背景图 -->
    <div class="HeaderBG">
      <img style="width: 100vw; height: 430px" src="@/assets/images/5_1.png" />
      <div class="flex" style="color: #191919">
        <div style="position: absolute; width: 1290px; top: 210px">
          <span class="carouselBlank">联系我们</span>
          <br /><br />
          <span class="carouselDes">24小时为您解答</span>
          <br /><br />
          <a
            class="carouselBtn"
            style="color: #191919"
            href="#"
            @click.prevent="$emit('childEvent')"
          >
            <img style="cursor: pointer" :src="require('@/assets/images/zixun(2).png')" />
          </a>
        </div>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="elMain flex">
      <div class="elMainCnt">

        <!-- 联系我们标题 -->
        <div class="section-title">
          <span>联系我们</span>
        </div>

        <!-- 地址 + 地图 -->
        <div>
          <el-container>
            <el-aside width="500px">
              <div class="info-block">
                <p class="info-title">公司地址</p>
                <p class="info-content">
                  深圳市福田区华强北街道华航社区深南中路3006号佳和华强大厦B座28层01-03房
                </p>
              </div>
              <div class="info-block" style="margin-top: 60px">
                <p class="info-title">联系电话</p>
                <p class="info-content">
                  客服电话：<span style="color: #c4171e">400-8898-012</span>
                </p>
              </div>
            </el-aside>
            <el-main style="padding: 0">
              <div
                :style="{ backgroundImage: 'url(' + dituImg + ')' }"
                style="height: 390px; width: 778px"
              >
                <div id="bai-du-map"></div>
              </div>
            </el-main>
          </el-container>
        </div>

        <div style="height: 150px"></div>

        <!-- 办公地点标题 -->
        <div class="section-title">
          <span>办公地点</span>
        </div>

        <!-- 办公地点列表 -->
        <div style="position: relative; top: 20px; overflow: hidden">
          <ul class="office-list">
            <li v-for="o in offices" :key="o.id" class="office-item">
              <p class="title" :style="o.id === 1 ? { color: '#c4171e' } : {}">
                {{ o.companyName }}
              </p>
              <p class="info">地址:&nbsp;&nbsp;{{ o.address }}</p>
              <p class="info">电话:&nbsp;&nbsp;{{ o.phone }}</p>
              <p v-if="o.qq" class="info">QQ:&nbsp;&nbsp;{{ o.qq }}</p>
              <p v-if="o.email" class="info">邮箱:&nbsp;&nbsp;{{ o.email }}</p>
              <p v-if="o.weChat" class="info">微信:&nbsp;&nbsp;{{ o.weChat }}</p>
            </li>
          </ul>
        </div>

        <div style="height: 100px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import parameterApi from "@/api/parameterApi";
import buttonView from "@/components/buttonView";

window._AMapSecurityConfig = {
  securityJsCode: "0db33c1e15e793aca7dde57a38ebf218",
};

export default {
  name: "contactMePage",
  components: { buttonView },
  data() {
    return {
      dituImg: require("@/assets/images/a332c70e0ee5123742a4aad28255b4a0.png"),
      // 兜底数据：后端 /company-info/list 不可用时展示（2026-09 按《官网联系信息合集2026.xlsx》整理）
      offices: [
        {
          id: 1,
          companyName: "深圳总部",
          address: "深圳市福田区深南中路佳和华强大厦B座28楼",
          phone: "400-8898-012 / 13528811227",
          qq: "2092239146",
          email: "2092239146@qq.com",
          weChat: "HJkefu8",
        },
        {
          id: 2,
          companyName: "宝安分公司",
          address:
            "深圳市宝安区新安街道创业二路洪浪北地铁站D出口玺玥大厦15层1505单元",
          phone: "0755-23576484 / 13723739044",
          qq: "381153028 / 1977390113",
          email: "381153028@qq.com / 1977390113@qq.com",
          weChat: "lixueming610",
        },
        {
          id: 3,
          companyName: "龙岗分公司",
          address:
            "广东省深圳市龙岗区龙城街道黄阁坑社区清林路524号天安数码创新园1号厂房A802-3",
          phone: "0755-85232622 / 15818598321",
          qq: "491217492",
          email: "491217492@qq.com",
          weChat: "Y491217492",
        },
        {
          id: 4,
          companyName: "龙华分公司",
          address: "龙华新区梅坂大道与雅宝路交汇处星河WORLD-B座2102室",
          phone: "0755-89358059",
          qq: "2821225283 / 545238589",
          email: "2821225283@qq.com / 545238589@qq.com",
          weChat: "HJlyh13713766917",
        },
        {
          id: 5,
          companyName: "罗湖分公司",
          address: "罗湖区宝安南路与解放路交汇处龙园创展大厦1805室",
          phone: "0755-83295076 / 13528406012",
          qq: "496602321 / 2510679028",
          email: "lifang713@126.com / 496602321@qq.com",
          weChat: "lf13528406012",
        },
        {
          id: 6,
          companyName: "上海分公司",
          address: "上海市闵行区七宝镇吴宝路255号力国大楼121室",
          phone: "021-67663177 / 13671976331",
          qq: "3365787821",
          email: "3365787821@qq.com",
          weChat: "cairunSH",
        },
        {
          id: 7,
          companyName: "杭州分公司",
          address: "杭州市西湖区文二路328号华星发展大厦B座B619",
          phone: "15355056720",
          qq: "491217492",
          email: "491217492@qq.com",
          weChat: "HJCR-hangzhou / Y491217492",
        },
        {
          id: 8,
          companyName: "广州分公司",
          address: "广州市天河区天河路490号壬丰大厦东厅2905-A",
          phone: "020-87544500 / 18122758129",
          qq: "3250724741 / 1350652719",
          email: "3250724741@qq.com",
          weChat: "A18122758129",
        },
        {
          id: 9,
          companyName: "厦门分公司",
          address: "厦门市思明区观音山运营中心165号901-1室",
          phone: "0592-5393978",
          qq: "2712696775",
          email: "2712696775@qq.com",
          weChat: "hjcr9981",
        },
        {
          id: 10,
          companyName: "长沙分公司",
          address:
            "湖南省长沙市芙蓉区朝阳街道韶山北路159号通程国际大酒店8楼007",
          phone: "13723739044",
          qq: "13723739044",
          email: "381153028@qq.com",
          weChat: "13723739044",
        },
        {
          id: 11,
          companyName: "武汉子公司",
          address: "武汉市武昌区中北路汉街总部国际B座33A05室",
          phone: "027-87266758",
          qq: "961790552",
          email: "961790552@qq.com",
          weChat: "HJ18502746838",
        },
        {
          id: 12,
          companyName: "成都分公司",
          address: "成都市锦江区东大街芷泉段东方广场C座1501",
          phone: "028-82070629 / 028-82070620",
          qq: "360387171",
          email: "360387171@qq.com",
          weChat: "cairunCD",
        },
        {
          id: 13,
          companyName: "西安分公司",
          address: "西安市碑林区长鑫领先国际2004b",
          phone: "029-83693193",
          qq: "505430037 / 3107097168",
          email: "zhouyongyi@hjcr88.com",
          weChat: "szhjxian / hj_Zhou7204",
        },
        {
          id: 14,
          companyName: "重庆分公司",
          address: "重庆市渝中区石油路龙湖时代天街B馆3号楼2705",
          phone: "023-88160515",
          qq: "507020649",
          email: "507020649@qq.com",
          weChat: "cq-hjcr666 / hj-cqjb666 / CQ-hjcr",
        },
      ],
      map: null,
      marker: null,
    };
  },
  computed: {
    ditu() {
      return this.$store.state.ditu;
    },
  },
  mounted() {
    if (this.ditu >= 2) {
      this.$store.commit("clearDitu");
      location.reload();
    }
    this.getOffice();
    this.initMap();
  },
  methods: {
    getOffice() {
      parameterApi
        .getOffice()
        .then((response) => {
          // 后端 /company-info/list 当前不可用（company_info 表字段缺失会 500），
          // 仅当返回有效数组时才覆盖，避免把兜底的办公地点数据冲成空
          const list = response && response.data && response.data.obj;
          if (Array.isArray(list) && list.length > 0) {
            this.offices = list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initMap() {
      AMapLoader.load({
        key: "",
        version: "2.0",
        plugins: [],
      })
        .then((AMap) => {
          this.marker = new AMap.Marker({
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
            position: [114.08466965012357, 22.54115254489021],
            anchor: "bottom-center",
          });
          this.map = new AMap.Map("bai-du-map", {
            viewMode: "2D",
            zoom: 14,
            center: [114.08466965012357, 22.54115254489021],
            resizeEnable: true,
          });
          this.map.add(this.marker);
          this.map.setFitView();
          this.$store.commit("setDitu", this.$store.state.ditu + 1);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>
@import url('../../assets/css/default.css');

#bai-du-map {
  overflow: hidden;
  width: 778px;
  height: 390px;
  margin: 0;
  font-family: '微软雅黑';
}

.amap-logo {
  display: none !important;
}

.amap-copyright {
  display: none !important;
}

.section-title {
  position: relative;
  right: -600px;
  margin-bottom: 30px;
}

.section-title span {
  font-family: PingFang SC Bold, sans-serif;
  font-weight: 700;
  font-size: 34px;
}

.info-block {
  margin-bottom: 10px;
}

.info-title {
  font-family: PingFang SC Bold, sans-serif;
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 16px;
}

.info-content {
  font-family: PingFang SC Medium, sans-serif;
  font-weight: 500;
  font-size: 18px;
}

.office-list {
  list-style: none;
  padding: 0;
  margin: 0;
  /* 办公地点较多，改为两列网格排布 */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 60px;
  row-gap: 40px;
}

.office-item {
  position: relative;
  min-width: 0;
}

.title {
  font-family: PingFang SC Bold, sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: 30px;
  text-align: left;
  color: #191919;
}

.info {
  font-family: PingFang SC Medium, sans-serif;
  font-weight: 500;
  font-size: 17px;
  line-height: 30px;
  text-align: left;
  color: #191919;
}
</style>
